import React, { useEffect, useRef, useState } from 'react';

export default function VideoPlayerOnClick({ src }) {
	const containerRef = useRef(null);
	const videoRef = useRef(null);
	const [isPlaying, setIsPlaying] = useState(false);
	const [isFullscreen, setIsFullscreen] = useState(false);

	useEffect(() => {
		const updateFullscreenState = () => {
			const fullscreenElement = document.fullscreenElement || document.webkitFullscreenElement;
			setIsFullscreen(!!(containerRef.current && fullscreenElement === containerRef.current));
		};

		document.addEventListener('fullscreenchange', updateFullscreenState);
		document.addEventListener('webkitfullscreenchange', updateFullscreenState);

		return () => {
			document.removeEventListener('fullscreenchange', updateFullscreenState);
			document.removeEventListener('webkitfullscreenchange', updateFullscreenState);
		};
	}, []);

	const handleVideoClick = () => {
		const video = videoRef.current;
		if (!video) return;

		if (video.paused) {
			video.play();
		} else {
			video.pause();
		}
	};

	const handleFullscreenClick = async (e) => {
		e.stopPropagation();

		const container = containerRef.current;
		const video = videoRef.current;
		if (!container && !video) return;

		try {
			if (isFullscreen) {
				if (document.exitFullscreen) {
					await document.exitFullscreen();
					return;
				}
				if (document.webkitExitFullscreen) {
					document.webkitExitFullscreen();
				}
				return;
			}

			if (container && container.requestFullscreen) {
				await container.requestFullscreen();
				return;
			}

			if (container && container.webkitRequestFullscreen) {
				container.webkitRequestFullscreen();
				return;
			}

			if (video && video.webkitEnterFullscreen) {
				video.webkitEnterFullscreen();
			}
		} catch (err) {
			console.error('Unable to enter fullscreen mode', err);
		}
	};

	return (
		<div ref={containerRef} className="video-thumbnail-container documentation-screen-video" onClick={handleVideoClick}>
			<video
				className='documentation-container-instruction-image docs-video-element'
				ref={videoRef}
				loop={false}
				muted
				style={{ width: '100%' }}
				src={src}
				onPlay={() => setIsPlaying(true)}
				onPause={() => setIsPlaying(false)}
				onEnded={() => setIsPlaying(false)}
			></video>
			{!isPlaying &&
				<div className="play-button-overlay"></div>
			}
			<button
				type='button'
				className='docs-video-fullscreen-btn'
				onClick={handleFullscreenClick}
				aria-label='Open video in fullscreen'
			>
				{isFullscreen ? 'Exit fullscreen' : 'Fullscreen'}
			</button>
		</div>
	);
}
